"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import type { JobadComponentProps } from "~/types/job";
export default function SloganPictureEonGridsolutions(_props) {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CustomImage alt="E.ON Grid Solutions Slogan" className="max-h-[700px] w-full object-cover" height={1080} src="images/jobad/eongrid/slogan2.jpg" width={1920} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section><div className="relative h-full w-full pointer-fine:bg-fixed print:hidden">{t0}<div className="absolute top-0 z-10 mx-auto flex h-full w-full items-center justify-center p-6 text-center md:px-10"><h2 className="bg-opacity-60 p-2 font-bold text-4xl text-white md:p-6 md:text-5xl" data-source="text"><p>Wenn schnell auch leise funktioniert,{" "}<span className="whitespace-nowrap">geht alles</span></p><p className="mt-2 md:mt-4">– vor allem Bleibendes.</p></h2></div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}